/**
 * `window` event the workbench dispatches when the preview shows only the starter template and
 * the founder clicks "Build prototype". The conversation module listens and retries the latest
 * plan's build (`handleRetryPrototyper`), the same as the prototype card's Retry.
 */
export const WORKBENCH_BUILD_MISSING_VERSION_EVENT = 'ideoz-workbench-build-missing-version';

/**
 * `window` events from the "saved in another tab" banner (P6.4e): load the newest saved version of
 * the turn, or save this tab's copy over it. The workbench facade listens.
 */
export const WORKBENCH_SAVE_CONFLICT_LOAD_LATEST_EVENT = 'ideoz-workbench-save-conflict-load-latest';
export const WORKBENCH_SAVE_CONFLICT_KEEP_MINE_EVENT = 'ideoz-workbench-save-conflict-keep-mine';
